import { ComponentPropsWithoutRef, FC } from "react";

import { twMerge } from "tailwind-merge";

type Props = ComponentPropsWithoutRef<"div">;

/**
 * Positioned column that map controls stack into. Owns placement only — every
 * control is passed in as a child, so a page composes the generic controls and
 * its own feature-specific ones in whatever order it needs.
 */
const MapControlCluster: FC<Props> = ({ className, children, ...props }) => (
  <div
    className={twMerge(
      "absolute bottom-[24px] right-[24px] z-[99] flex flex-col items-center",
      className
    )}
    {...props}
  >
    {children}
  </div>
);

export default MapControlCluster;
